
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class WifiWM2000Node extends BaseNode {
    constructor() {
        super();
        this.name = 'Wi-Fi';
        this.id = 'node_wifiwm2000';
        this.linkedFeature = 'wifiwm2000';
        this.requirements = ['WM2000'];
        this.outputs = [
            {
                name: 'Wi-Fi Connected',
                portId: 'wifiwm2000_connected',
                params: [],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'wifiwm2000_connected');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: project.getNetworkConnectedLocation('PL_SOCK_INTERFACE_WLN'),
                blockType: BlockType.CODE,
                template: `
    '****${link.getSourceId()}****'`,
            });
        }

        return blocks;
    }
}
